import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import { Text } from '@/components/ui/index.js';
import styles from './FilterPill.module.css';

/**
 * FilterPill - Active filter indicator with remove action
 * Shows currently applied filters as removable pills
 */
export function FilterPill({ label, value, type, onRemove }) {
  return (
    <div className={styles.pill}>
      <Text size="xs" color="secondary" className={styles.label}>
        {label}
      </Text>
      <button
        type="button"
        className={styles.removeButton}
        onClick={() => onRemove(type, value)}
        aria-label={`Remove ${label} filter`}
      >
        <X size={12} />
      </button>
    </div>
  );
}

FilterPill.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default FilterPill;
